import * as React from "react";

import { U14_COMPETITIONS } from "../../containers/competition/constants";
import CompetitionMatches from "../../containers/competitionMatches";
import { TYPE } from "../../containers/competitionMatches/constants";
import Competitions from "../../containers/competitions";
import CompetitionTableSummary from "../../containers/competitionTableSummary";
import HomeHighlights from "../../containers/homeHighlightsSection";
import HomeNewsSection from "../../containers/homeNewsSection";
import NationalTeamMatches from "../../containers/nationalTeamMatches";
import NationalTeams from "../../containers/nationalTeams";
import PastMatchesSection from "../../containers/pastMatchesSection";
import UpcomingMatchesSection from "../../containers/upcomingMatchesSection";
import BannerAdvertisement from "../bannerAdvertisement";
import LeaderboardOrSquareAdvertisement from "../leaderboardOrSquareAdvertisement";
import styles from "./critical.scss";

const DEFAULT_COMPETITION = 58539;

const LABELS = {
  TITLE_NEWS: "LATEST NEWS",
  TITLE_HIGHLIGHTS: "HIGHLIGHTS",
  TITLE_UPCOMING: "UPCOMING MATCHES",
  TITLE_PAST: "LATEST RESULTS",
  TITLE_NATIONAL_TEAM_PAST: "NATIONAL TEAM RESULTS",
  COMPETITION_TITLE: "Competition:",
};

const HomePage = () => {
  const [competitionId, setCompetitionId] = React.useState(DEFAULT_COMPETITION);
  const [selectedCompetition, setSelectedCompetition] =
    React.useState(DEFAULT_COMPETITION);

  return (
    <div className={styles.container}>
      <section className={styles.content}>
        <NationalTeams>
          {(nationalTeams) =>
            nationalTeams.map(({ name, themeColor1, nationalTeamId }) => (
              <NationalTeamMatches
                key={nationalTeamId}
                nationalTeamId={nationalTeamId}
                type={TYPE.LIVE}
                subtitle={name}
                subtitleColor={themeColor1}
                pageSize={1}
              />
            ))
          }
        </NationalTeams>
        <Competitions>
          {(competitions) => {
            return (
              <>
                {competitions
                  .filter((n) => n.hasLive)
                  .map(({ id, name, themeColor1, matchPageSize }) => (
                    <CompetitionMatches
                      key={id}
                      competitionId={id}
                      type={TYPE.LIVE}
                      subtitle={name}
                      subtitleColor={themeColor1}
                      pageSize={matchPageSize}
                    />
                  ))}
                <div className={styles.filters}>
                  <div className={styles.filter}>
                    <label htmlFor="competition" className={styles.filterTitle}>
                      {LABELS.COMPETITION_TITLE}
                    </label>
                    {Boolean(competitions && competitions.length) && (
                      <select
                        id="competition"
                        className={styles.list}
                        defaultValue={DEFAULT_COMPETITION}
                        onChange={(e) => {
                          setCompetitionId(e.target.value);
                          setSelectedCompetition(
                            competitions.find(
                              (m) => m.id === parseInt(e.target.value, 10)
                            ) || {}
                          );
                        }}
                      >
                        {competitions.map((n) => (
                          <option
                            className={`${styles.listItem}`}
                            key={n.id}
                            value={n.id}
                          >
                            {n.name}
                          </option>
                        ))}
                      </select>
                    )}
                  </div>
                </div>
              </>
            );
          }}
        </Competitions>
        <UpcomingMatchesSection
          title={LABELS.TITLE_UPCOMING}
          competitionId={competitionId}
        />
        <LeaderboardOrSquareAdvertisement uid="home-page-3" />
        <PastMatchesSection
          title={LABELS.TITLE_PAST}
          className={styles.pastMatches}
          showPagination={false}
          competitionId={competitionId}
        />
        <LeaderboardOrSquareAdvertisement uid="home-page-1" />
        <h2>{LABELS.TITLE_NATIONAL_TEAM_PAST}</h2>
        <NationalTeams>
          {(nationalTeams) =>
            nationalTeams.map(({ name, themeColor1, nationalTeamId }) => (
              <NationalTeamMatches
                key={nationalTeamId}
                nationalTeamId={nationalTeamId}
                type={TYPE.PAST}
                subtitle={name}
                subtitleColor={themeColor1}
                pageSize={1}
              />
            ))
          }
        </NationalTeams>
      </section>
      <aside className={styles.aside}>
        {!(
          selectedCompetition.isCup ||
          selectedCompetition.isSuperCup ||
          U14_COMPETITIONS.includes(competitionId.toString())
        ) && <CompetitionTableSummary competitionId={competitionId} />}
        <HomeNewsSection title={LABELS.TITLE_NEWS} />
        <HomeHighlights title={LABELS.TITLE_HIGHLIGHTS} />
        <BannerAdvertisement uid="home-page-2" />
      </aside>
    </div>
  );
};

export default HomePage;
